import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/Auth";
import { RoomDetailsApi } from '../services/Api';


export default function RoomDetails({ bookingSlotItems, setBookingSlotItems }) {
    const [room, setRoom] = useState(null);
    const [qty, setQty] = useState(1);
    const { id } = useParams();
    const [checkIn, setCheckIn] = useState("");
    const [days, setDays] = useState(1);

    useEffect(() => {
        if (isAuthenticated()) {
            RoomDetailsApi(id).then(res => setRoom(res.data.room))
        }
    }, [id])

    function addToBookingSlot() {
        const itemExist = bookingSlotItems.find((item) => item.room._id === room._id)
        if (!itemExist && checkIn) {
            const newItem = { room, qty, checkIn, days };
            setBookingSlotItems((state) => [...state, newItem]);
            toast.success("Room added on BookingSlot succesfully!")
        } else if (!checkIn) {
            toast.error("Please Select Check In date")
        }
        else {
            toast.info("Already this varient added. Please check or customise on Booking Slot")
        }
    }

    function increaseQty() {
        if (room.vacancies <= qty) {
            return;
        }
        setQty((state) => state + 1);
    }

    function decreaseQty() {
        if (qty > 1) {
            setQty((state) => state - 1);
        }
    }
    if (!isAuthenticated()) {
        //redirect user to login
        return <Navigate to="/login" />
    }


    return (<>
        {room && <div className="container-fluid p-5">
            <div className="row">
                <div className="col-12 col-lg-7 text-center">
                    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active" data-bs-interval="3000">
                                <img className="img-fluid w-100" src={room.images[0].image} alt={room.name} height="550" width="550" />
                            </div>
                            <div className="carousel-item" data-bs-interval="3000">
                                <img className="img-fluid w-100" src={room.images[1].image} alt={room.name} height="550" width="550" />
                            </div>
                            <div className="carousel-item" data-bs-interval="3000">
                                <img className="img-fluid w-100" src={room.images[2].image} alt={room.name} height="550" width="550" />
                            </div>
                            <div className="carousel-item" data-bs-interval="3000">
                                <img className="img-fluid w-100" src={room.images[3].image} alt={room.name} height="550" width="550" />
                            </div>
                            <div className="carousel-item" data-bs-interval="3000">
                                <img className="img-fluid w-100" src={room.images[4].image} alt={room.name} height="550" width="550" />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>

                <div className="col-12 col-lg-5 mt-5 text-center">
                    <h3>{room.name}</h3>
                    <p className=' fst-italic'>Room #{room._id}</p>

                    <hr />

                    <div className="rating-outer">
                        <div className="rating-inner" style={{ width: `${room.ratings / 5 * 100}%` }}></div>
                    </div>


                    <hr />
                    <div className=' d-flex justify-content-center'>
                        <h5>Per Day Cost: </h5>
                        <h5 className='fw-bolder text-danger ms-3'>Rs. {room.price}</h5>
                    </div>

                    <div className=' d-flex justify-content-center my-2'>
                        <div className='me-2'>
                            <label className='form-label h6' htmlFor="checkIn">Check IN</label>
                            <input className='form-control' type="date" id='checkIn' name='checkIn' value={checkIn} onChange={(e) => setCheckIn(e.target.value)} />
                        </div>
                        <div>
                            <label className='form-label h6' htmlFor="days">Days</label>
                            <div className='d-flex justify-content-center'>
                                <input className='form-control text-center w-50' type="number" id='days' name='days' min={1} max={365} value={days} onChange={(e) => setDays(e.target.value)} />
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className='d-flex justify-content-center my-3'>
                        <div>
                            <h5 className='mt-2'>Total Rooms:</h5>
                        </div>

                        <div className="d-flex justify-content-evenly">
                            <span className="btn btn-danger" onClick={decreaseQty}>-</span>

                            <input className='form-control text-center w-25' type="number" name="qty" value={qty} readOnly />

                            <span className="btn btn-primary" onClick={increaseQty}>+</span>
                        </div>
                    </div>

                    <button type="button" onClick={addToBookingSlot} disabled={room.vacancies <= 0} className="btn btn-primary">Add to Booking Slot</button>


                    <hr />

                    <p className='fw-bold'>Status <h5 className={room.vacancies > 0 ? 'text-success' : 'text-danger'}>{room.vacancies > 0 ? 'Avaliable' : 'Un Avaliable'}</h5></p>
                    <hr />

                    <h4 className="mt-2">Description</h4>
                    <p>{room.description}</p>
                    <hr />
                    <h4 className="mt-2">Category</h4>
                    <h6 className="card-text text-danger">{room.category}</h6>
                    <hr />
                    <div className='d-flex justify-content-between'>
                        <div>
                            <h5>AC</h5>
                            <h6 className='text-success'>{room.ac}</h6>
                        </div>
                        <div>
                            <h5>WIFI</h5>
                            <h6 className='text-success'>{room.wifi}</h6>
                        </div>
                        <div>
                            <h5>TV</h5>
                            <h6 className='text-success'>{room.tv}</h6>
                        </div>
                        <div>
                            <h5>Heater</h5>
                            <h6 className='text-success'>{room.heater}</h6>
                        </div>
                    </div>

                </div>

            </div>
        </div>}
    </>)
}